import { defineMessages } from 'react-intl';

import {
  LEARNING_RESOURCE_TAG,
  LEARNING_RESOURCE_TYPE,
} from '@didaskill/domain/learning-resources/constants';

export const learningResourceTagMessages = defineMessages<keyof typeof LEARNING_RESOURCE_TAG>({
  [LEARNING_RESOURCE_TAG.THEMATIC]: {
    defaultMessage: 'Thématique',
  },
  [LEARNING_RESOURCE_TAG.METHODOLOGY]: {
    defaultMessage: 'Méthodologie',
  },
  [LEARNING_RESOURCE_TAG.PRACTICE]: {
    defaultMessage: 'Pratique',
  },
  [LEARNING_RESOURCE_TAG.INTENSIVE_REVIEWS]: {
    defaultMessage: 'Révisions intensives',
  },
  [LEARNING_RESOURCE_TAG.MOCK_ORAL]: {
    defaultMessage: 'Oral blanc',
  },
  [LEARNING_RESOURCE_TAG.INTERNSHIP]: {
    defaultMessage: 'Stage',
  },
  [LEARNING_RESOURCE_TAG.ENTERTAINMENT]: {
    defaultMessage: 'Animation',
  },
  [LEARNING_RESOURCE_TAG.COACHING]: {
    defaultMessage: 'Coaching',
  },
  [LEARNING_RESOURCE_TAG.TUTORIAL]: {
    defaultMessage: 'Tutoriel',
  },
  [LEARNING_RESOURCE_TAG.EXAM]: {
    defaultMessage: 'Examens',
  },
  [LEARNING_RESOURCE_TAG.PRIVATE]: {
    defaultMessage: 'Évènement privé',
  },
});

export const learningResourceTypesMessages = defineMessages<LEARNING_RESOURCE_TYPE>({
  [LEARNING_RESOURCE_TYPE.FILE]: {
    defaultMessage: 'Fichier',
  },

  [LEARNING_RESOURCE_TYPE.VIDEO]: {
    defaultMessage: 'Vidéo',
  },

  [LEARNING_RESOURCE_TYPE.AUDIO]: {
    defaultMessage: 'Audio',
  },
  [LEARNING_RESOURCE_TYPE.REPLAY]: {
    defaultMessage: 'Replay',
  },
} as const);
